import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { HeroWidgetForm } from './HeroWidgetForm/HeroWidgetForm';
import { HeroWidgetModelType } from 'src/api/config/hero_widget/get_hero_widget';
import { HeroWidgetListItem } from './HeroWidgetListItem/HeroWidgetListItem';
import { ColumnOneOfTwo, MainContent, TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';
import { ListContainer } from 'src/domains/layouts/shared/cms/list/List.style';

export const HeroWidget = observer(() => {
    const { heroWidgetState } = useAppStateContext();
    const { isLoading, heroWidgetList } = heroWidgetState;

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwo>
                    <ListContainer areLoading={isLoading}>
                        <Loader isActive={isLoading} />
                        {heroWidgetList.map((heroWidget: HeroWidgetModelType) => {
                            return <HeroWidgetListItem key={heroWidget.id} heroWidget={heroWidget} />;
                        })}
                    </ListContainer>
                </ColumnOneOfTwo>

                <ColumnOneOfTwo>
                    <HeroWidgetForm />
                </ColumnOneOfTwo>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});
